import { Language } from "../../constants/language";
import { ProductType } from "../product/product";

export interface Filter {
  
	priceRange?: {
		min: number;
		max: number;
	};
	language?: Language[];
	type?: ProductType[];
	inStock?: boolean;
	featured?: boolean;
	rating?: number; // minimum rating
}

export interface SortOption {
  field: string;
  direction: 'asc' | 'desc';
}

export enum FilterViewMode {
	GRID = 'grid',
	LIST = 'list',
	CARD = 'card',
}